import script from "./appletLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./appletLogin.vue?vue&type=script&setup=true&lang=ts"

import "./appletLogin.vue?vue&type=style&index=0&id=20ff789e&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ff789e"]])

export default __exports__